import { StorageModel, StorageSimpleModel } from '../../types/warehouse/model';

export function getStorageSimpleModel(storage?: StorageModel): StorageSimpleModel | null {
    return storage ? {
        id: storage.id,
        name: storage.name,
    } : null;
}
